import {useUpmPlant} from '@hconnect/upm'
import {Loading} from '@hm/fundamental'
import {useSearchParams} from 'react-router'

import {useShutdownsQuery} from '@refra/modules/common/hooks/queries'
import {ShutdownsProvider, useKilns} from '@refra/modules/common/providers'
import {useUrlParam} from '@refra/modules/routing/hooks'

interface RefraStaticPartsShutdownsWrapperProps {
  children: React.ReactNode
}

export const RefraStaticPartsShutdownsWrapper: React.FC<RefraStaticPartsShutdownsWrapperProps> = ({
  children
}) => {
  const plantCode = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId: plantCode})
  const [searchParams] = useSearchParams()
  const shutdownId = searchParams.get('shutdownId') ?? undefined
  const {selectedKiln} = useKilns()

  const {data: shutdowns} = useShutdownsQuery({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  if (!shutdowns) {
    return <Loading size="large" data-cy="static_part_detail_shutdowns_loader" />
  }

  return (
    <ShutdownsProvider shutdowns={shutdowns} selectedShutdownId={shutdownId}>
      {children}
    </ShutdownsProvider>
  )
}
